<template>
    <div>
        <b-toast toaster="b-toaster-top-center" id="success" variant="success" title="Succès" @hidden="alertStoreState.successMsg = []">
            <div v-for="(msg, index) in alertStoreState.successMsg" :key="index">
                {{msg}}
            </div>
        </b-toast>
        <b-toast toaster="b-toaster-top-center" no-auto-hide id="warning" variant="warning" title="Avertissement(s)"  @hidden="alertStoreState.warningMsg = []">
            <div v-for="(msg, index) in alertStoreState.warningMsg" :key="index">
                {{msg}}
            </div>
        </b-toast>
        <b-toast toaster="b-toaster-top-center" no-auto-hide id="error" variant="danger" title="Erreur(s)" @hidden="alertStoreState.errorMsg = []">
            <div v-for="(msg, index) in alertStoreState.errorMsg" :key="index">
                {{msg}}
            </div>
        </b-toast>
      <b-toast toaster="b-toaster-top-center" no-auto-hide id="info" variant="info" title="Info(s)" @hidden="alertStoreState.infoMsg = []">
        <div v-for="(msg, index) in alertStoreState.infoMsg" :key="index">
          {{msg}}
        </div>
      </b-toast>
    </div>
</template>

<script>
  import AlertStore from '@/stores/AlertStore'
  import {EventBus} from '@/event-bus'

  export default {
    name: "Alert",
    data() {
      return {
        alertStoreState: AlertStore.state
      }
    },
    mounted() {
      EventBus.$on('AlertComponent-push', (alertType) => {
        this.$bvToast.show(alertType);
      });
      EventBus.$on('AlertComponent-clear', (clearType) => {
        if (!clearType) {
          this.clearType('success');
          this.clearType('warning');
          this.clearType('error');
        } else {
          this.clearType(clearType);
        }
      });
    },
    methods: {
      clearType(clearType) {
        this.$bvToast.hide(clearType);
      }
    }
  }
</script>
